import { render, staticRenderFns } from "./ExchangePicker.vue?vue&type=template&id=2ff132b8&lang=pug"
import script from "./ExchangePicker.vue?vue&type=script&lang=js"
export * from "./ExchangePicker.vue?vue&type=script&lang=js"
import style0 from "./ExchangePicker.vue?vue&type=style&index=0&id=2ff132b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports